module.exports = __webpack_public_path__ + "static/media/down_arrow_white.5a374157.svg";